// extracted by mini-css-extract-plugin
module.exports = {"Container":"LoadingButton_Container__FJpUr","Spinner":"LoadingButton_Spinner__1e4Tb","Hidden":"LoadingButton_Hidden__3b78I"};